import { $ } from "@olmokit/dom";
import AuthFormPasswordRecovery from "@olmokit/core/auth/form-password-recovery";
import FormsInputMaterial from "@olmokit/core/forms/input/material";
import "@olmokit/core/forms/checkbox";
import "./index.scss";

/**
 * Component: Form password recovery
 */
export function FormPasswordRecovery() {
  const $error = $(".FormPasswordRecovery: .error");

  AuthFormPasswordRecovery(null, {
    succeded: (formData, instance, response) => {
      $error.innerHTML = response?.data?.msg || "";
    },
    failed: (formData, instance, response) => {
      $error.innerHTML = response?.data?.msg || "";
    },
  });

  FormsInputMaterial();
}
